/**
 * i18n.js
 *
 * This will setup the i18n language files and locale data for your app.
 *
 *   IMPORTANT: This file is used by the internal build
 *   script `extract-intl`, and must use CommonJS module syntax
 *   You CANNOT use import/export in this file.
 */
const addLocaleData = require("react-intl").addLocaleData; //eslint-disable-line
const enLocaleData = require("react-intl/locale-data/en");
const nlLocaleData = require("react-intl/locale-data/nl");
let getLanguage = () => null;
if (typeof window !== "undefined") {
  // eslint-disable-next-line global-require
  const userStorage = require("utils/userStorage");
  getLanguage = userStorage.getLanguage;
}

const enTranslationMessages = require("./translations/en.json");
const nlTranslationMessages = require("./translations/nl.json");

addLocaleData(enLocaleData);
addLocaleData(nlLocaleData);

const appLocales = ["en", "nl"];

const DEFAULT_LOCALE = getBrowserLanguage();

function getBrowserLanguage() {
  let found = getLanguage();
  if (!found) {
    found = typeof window !== "undefined" ? window.navigator.language : "en";
  }

  let language = "en";
  if (!found || !(typeof found === "string")) {
    language = "en";
  } else {
    found = found.toLowerCase();
    language = appLocales.find(locale => found.includes(locale.toLowerCase()));
    if (!language) {
      language = "en";
    }
  }

  return language;
}

const formatTranslationMessages = (locale, messages) => {
  const defaultFormattedMessages =
    locale !== DEFAULT_LOCALE
      ? formatTranslationMessages(DEFAULT_LOCALE, enTranslationMessages)
      : {};
  const flattenFormattedMessages = (formattedMessages, key) => {
    const formattedMessage =
      !messages[key] && locale !== DEFAULT_LOCALE
        ? defaultFormattedMessages[key]
        : messages[key];
    return Object.assign(formattedMessages, { [key]: formattedMessage });
  };
  return Object.keys(messages).reduce(flattenFormattedMessages, {});
};

const translationMessages = {
  en: formatTranslationMessages("en", enTranslationMessages),
  nl: formatTranslationMessages("nl", nlTranslationMessages),
};

function getTranslation(text){
  return translationMessages[DEFAULT_LOCALE][text]
}

exports.appLocales = appLocales;
exports.formatTranslationMessages = formatTranslationMessages;
exports.translationMessages = translationMessages;
exports.DEFAULT_LOCALE = DEFAULT_LOCALE;
exports.getTranslation = getTranslation;
